// extracted by mini-css-extract-plugin
module.exports = {"root":"Caption_root__9EA_G","uppercase":"Caption_uppercase__NK8Oj","italic":"Caption_italic__fRWUs","reveal-media":"Caption_reveal-media__HrQgk"};